<div mat-dialog-title>
    {{message}}
    <mat-progress-bar mode="indeterminate" class="thin-progress"></mat-progress-bar>
</div>

<mat-dialog-content style="width: 480px; height: auto;overflow: hidden;">

    <ng-container *ngFor="let group of viewModel.items;" style="margin-bottom: 16px">
        <!-- <div style="width: 20px; margin-right: 10px;">
                <mat-spinner *ngIf="item.isRunning" diameter="20" color="#ffbb00"></mat-spinner>
            </div> -->
        <div *ngIf="group.items.length > 0">
            <!-- <mat-expansion-panel expanded="True">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        <span style="font-weight: 500;">{{group.groupName}}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header> -->
            <ng-container *ngFor="let group of viewModel.items">
              <!--  <span style="font-weight: 500;">{{group.groupName}}</span>-->
                <div style=" margin-top: 0px; display: flex; align-items: center; justify-content: center;">

                  <!--  <span *ngIf="group.items.length == 0"
                        style="color: gray; display: flex; justify-content: center; align-items: center;">No
                        transforms</span>-->

                    <!-- <mat-list style="height:auto; margin-bottom: 16px; margin-top: 0px"> -->
                    <div style="height:auto; margin-bottom: 16px; margin-top: 0px">
                        <!-- <mat-list-item *ngFor="let item of group.items"> -->
                        <ng-container *ngFor="let item of group.items">
                            <div style="width: 100%; display: flex; align-items: center; justify-content: center;">
                                <div style="width: 20px; margin-right: 10px;">
                                    <mat-spinner *ngIf="item.isRunning" diameter="20" color="#ffbb00"></mat-spinner>
                                </div>
                                <span style="width: 150px"
                                    [ngStyle]="{'color': item.isActiveTransform ? '#1ea9d3' : 'white' }">{{item.name}}</span>
                                <span style="margin-left: 20px; width: 75px"
                                    [ngStyle]="{'color': viewModel.getItemStatusTextColor(item) }">{{item.statusDisplayText}}
                                </span>
                                <span style="margin-left: 10px; width: 80px"
                                    [ngStyle]="{'color': item.isActiveTransform ? '#1ea9d3' : 'white' }">{{item.cacheUpdatedStatus}}</span>
                                <span style="margin-left: 10px; width: 100px"
                                    [ngStyle]="{'color': item.isActiveTransform ? '#1ea9d3' : 'white' }">{{item.transformerTime}}</span>
                            </div>
                        </ng-container>
                        <!-- </mat-list-item> -->
                    </div>
                    <!-- </mat-list> -->
                </div>
            </ng-container>
            <!-- </mat-expansion-panel> -->
        </div>
    </ng-container>

</mat-dialog-content>

<mat-dialog-actions align="center">
    <!-- <button mat-raised-button mat-dialog-close tabindex="-1">Dismiss</button> -->
    <button mat-raised-button (click)="cancel()" [disabled]="isCancelling" tabindex="-1"
            matTooltip="Stop this run. If it's still actively progressing, you'll be asked to confirm first.">Cancel</button>
    <button color="primary" mat-raised-button (click)="runInBackground()" tabindex="-1">Run in background</button>
</mat-dialog-actions>